import React, { memo } from "react";

import closeIcon from "../../../../assets/icons/closeIcon.svg";
import {
  settlementStatusOptions,
  transactionStateOptions,
  verifiedByUserOptions,
} from "../../../../lib/constants";
import { unixToPersian } from "../../../../utils/utils";

const FilterDetailBar = memo(({ searchTerm, labelFields, setSearchTerm }) => {
  const cleanedSearchTerm = Object.entries(searchTerm).reduce((acc, [key, value]) => {
    if (
      key !== "transaction_type" &&
      key !== "order_by" &&
      key !== "descending" &&
      value !== undefined &&
      value !== ""
    ) {
      acc[key] = value;
    }
    return acc;
  }, {});

  const translatedArray = Object.entries(cleanedSearchTerm).map(([key, value]) => {
    const translatedKey = labelFields[key] || key;

    if (key === "from_invoice_time" || key === "to_invoice_time") {
      ////console.log(value,unixToPersian(convertToUnix(value)),"value")
      value = unixToPersian(value);
    }
    if (key === "transaction_state") {
      const option = transactionStateOptions.find((option) => option.value === value);
      if (option) {
        value = option.label; // Map to Persian label
      }
    }
    if (key === "settlement_status") {
      const option = settlementStatusOptions.find((option) => option.value === value);
      if (option) {
        value = option.label; // Map to Persian label
      }
    }
    if (key === "verified_by_user") {
      const option = verifiedByUserOptions.find((option) => option.value === value);
      if (option) {
        value = option.label; // Map to Persian label
      }
    }
    if (key === "gateway_id" || key === "form_id") {
      value = value.label; // Map to Persian label
    }
    return {
      englishKey: key,
      persianKey: translatedKey,
      value: value,
    };
  });

  const removeSearchItemHandler = (name) => {
    setSearchTerm((prev) => ({ ...prev, [name]: "" }));
  };

  return (
    <div className=" my-2  rounded-lg  flex flex-wrap gap-4 ">
      {translatedArray.map((item, i) => {
        return (
          <div className="flex-between bg-[#CED3D9]   px-2 gap-1 rounded-md text-dark title-sm-regular-UL">
            <button onClick={(e) => removeSearchItemHandler(item.englishKey)}>
              <img
                className=" hover:bg-slate-200  "
                src={closeIcon}
                alt="close-icon"
                width={24}
                height={24}
              />
            </button>
            <div className="flex gap-1" key={i}>
              <p className="title-sm-regular-UL">{item.persianKey}</p>:
              <p className="title-sm-regular-UL"> {item?.value}</p>
            </div>
          </div>
        );
      })}
    </div>
  );
});

export default FilterDetailBar;
